var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.userInClub
        ? _c("ClubInfoBanner", {
            attrs: {
              "show-info-icon": "",
              title: "Клубная цена",
              subtitle: "На все услуги клиники",
            },
          })
        : _c("ClubDiscountSwitch", {
            attrs: {
              "use-global-dispatch": "",
              title: "Клубная цена",
              enabled: _vm.isSwitchEnabled,
              discount: _vm.discountOnServices,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }